<ng-container *uiModalDescription>
  <div class="kpi-info">
    <i ui-icon uiType="kpi" uiTheme="fill"></i>
    <h5 [uiTooltipTitle]="kpi.name" [attr.aria-label]="('kpi_name' | localize) + ' ' + kpi.name" tooltipIfOverflow="hover" uiTooltipPlacement="bottom" ui-tooltip>{{ kpi.name }}</h5>
  </div>
</ng-container>

<form [formGroup]="kpiCommentForm">
  <div class="target-and-value">
    <div class="form-item target-type">
      <div class="control-label">{{ "comment_over" | localize }}</div>
      <ui-radio-group formControlName="targetType">
        <label uiValue="kpi_projection" ui-radio>{{ "projection" | localize }}</label>
        <label uiValue="kpi_snapshot" ui-radio>{{ "data_point" | localize }}</label>
      </ui-radio-group>
    </div>

    <div class="current-value" *ngIf="selectedPointValue !== undefined">
      <formatted-value [value]="selectedPointValue" [formatting]="kpi.formatting" [maximumFractionDigits]="5" maxFormattingUnitWidth="70px"></formatted-value>
      <i
        class="text-color-warning-10"
        *ngIf="showTodaySnapshotWarning"
        [uiTooltipTitle]="'your_comment_will_move_with_the_data_point_if_it_changes_before_the_end_of_the_date' | localize"
        ui-icon
        ui-tooltip
        uiType="attention"
        uiTheme="outline"></i>
    </div>
  </div>

  <div class="form-item">
    <div class="control-label" *ngIf="kpiCommentForm.value.targetType === 'kpi_snapshot'">{{ "select_existing_update" | localize }}</div>
    <div class="control-label" *ngIf="kpiCommentForm.value.targetType === 'kpi_projection'">{{ "select_existing_projection" | localize }}</div>
    <ui-date-picker
      [uiOpen]="false"
      [uiBackdrop]="true"
      [attr.aria-label]="kpiCommentForm.value.targetDate | date"
      [uiDisabledDate]="isDateDisabled.bind(this)"
      formControlName="targetDate"
      a11yLabelledby="target-date-label-to-do"
      data-test-id="kpi-comment-form-target-date-picker"></ui-date-picker>
  </div>

  <div class="form-item">
    <div class="control-label">{{ "comment" | localize }}</div>
    <rich-text-editor-with-mentions
      [placeholder]="'your_comment_placeholder' | localize"
      [postButtonA11yLabel]="'post_a_comment' | localize"
      formControlName="comment"
      data-test-id="update-comment-input-field"
      a11yLabelledby="comment-label-to-do"></rich-text-editor-with-mentions>
  </div>
</form>
